
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeTaskGrid extends Serenity.EntityGrid<ProdottiEsperienzeTaskRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzeTaskColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzeTaskDialog; }
        protected getIdProperty() { return ProdottiEsperienzeTaskRow.idProperty; }
        protected getInsertPermission() { return ProdottiEsperienzeTaskRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzeTaskService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}